
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useRegionCount(): CountResult {
  return useSupabaseCount("regions", "region-count");
}
